import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import {MailOutlined } from '@ant-design/icons'
import { Link } from "react-router-dom";
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import RoomIcon from '@mui/icons-material/Room';

const contactusContent = () => {
  return (
    <section className=" contact-us-wrap ">
      <Container>
        <div className="row">
          <div className="col-lg-12 ">
            <h2 className="main-title">Contact Us</h2>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="contact-heading">
              Thanks for wanting to connect with us!
            </div>
            {/* <div className="sub-heading">
              Vestibulum eu rhoncus ex. Donec sollicitudin nunc sed metus
              tincidunt, quis ultricies purus cursus.<Link to="">Maecenas scelerisque</Link>{" "}  mi
              nec tristique pharetra
            </div> */}
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="verification-wrap">
              <div className="row">
                <div className="col-sm-12">
                  <div className="get-in-touch">GET IN TOUCH WITH US</div>
                </div>
              </div>

              <div className="handles-content">

             

              <div className="row">
                <div className="col-sm-6">
                  <div className="handles-wrap">
                    <div className="contact-icon"><MailOutlined />
                    <div className="name">Email</div></div>
                    <div className="info">
                      If you are facing any issue/ or for feedback, write to us
                      at <Link to=" ">info@skycars.in</Link>{" "}
                    </div>
                  </div>
                </div>

                <div className="col-sm-6">
                  {" "}
                  <div className="handles-wrap">
                    <div className="contact-icon"><PermPhoneMsgIcon />
                    <div className="name">Phone</div></div>
                    <div className="info">
                     <Link to="">00 0000 0000</Link>{" "} <br/>
                     (Standard STD/local charges apply)
                    </div>
                  </div>
                </div>

                {/* <div className="col-sm-4">
                  {" "}
                  <div className="handles-wrap">
                    <div className="contact-icon"><RoomIcon />
                    <div className="name">POSTAL ADDRESS</div></div>
                    <div className="info">
                      <Link to=" ">Skycars</Link> <br/> Orci varius natoque penatibus et
                      magnis dis parturient montes
                    </div>
                  </div>
                </div> */}
              </div>
              </div>


            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default contactusContent;
